import jwt_decode from "jwt-decode";
function getUserDetails() {
    let data;
    try {
        if (localStorage.getItem('userDetails')) {
            data = JSON.parse(localStorage.getItem('userDetails'));
        }
        else {
            data = {};
        }
    }
    catch (err) {
        return err;
    }
    return data;
}

function getClientDetails() {
    let data;
    try {
        if (localStorage.getItem('clientDetails')) {
            data = JSON.parse(localStorage.getItem('clientDetails'));
        }
        else {
            data = {};
        }
    }
    catch (err) {
        return err;
    }
    return data;
}

function setUserDetails(details) {
    localStorage.setItem('userDetails', JSON.stringify(details));
}

function setClientDetails(details) {
    localStorage.setItem('clientDetails', JSON.stringify(details));
}


function getToken() {
    return localStorage.getItem('tok_recep');
}

function setToken(token) {
    localStorage.setItem('tok_recep', token);
    this.setPartner();
}

function getSpinner() {
    return localStorage.getItem('spinner') || 'circle';
}
function setSpinner(spinner) {
    localStorage.setItem('spinner', spinner);
}

function getNotificationIds() {
    return localStorage.getItem('notif_ids') || '';
}

function logout() {
    this.setToken("");
    this.setUserDetails("");
}

function setPartner(p) {
    if(p && p!=''){
        localStorage.setItem('partner_id', p);
    } 
    else if (this.getToken()!='') {
        let data = jwt_decode(this.getToken());
        if(data.partner) {
            localStorage.setItem('partner_id', data.partner);
        }
      }
}

function getPartner(p) {
    return localStorage.getItem('partner_id') || null;
}

var partner_details = null;
function setPartnerDetails(p) {
    partner_details = p;
}

function getPartnerDetails(p) {
    return partner_details;
}


var LocalStorageService = {
    getUserDetails,
    setUserDetails,
    getToken,
    setToken,
    getSpinner,
    setSpinner,
    getNotificationIds,
    logout,
    setClientDetails,
    getClientDetails,
    setPartner,
    getPartner,
    setPartnerDetails,
    getPartnerDetails
}

export default LocalStorageService;


// WEBPACK FOOTER //
// ./services/LocalStorageService.js